import { ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { CalendarComponent } from "../../calendar/calendar.component";
import { ActivatedRoute, Router } from "@angular/router";
import { CalendarService } from "../../../domain/calendar-service";
import { CalendarSearchService } from "../../calendar/services/calendar-search.service";
import { Socket } from "../../../infrastructure/socket.service";
import { UserService } from "../../../domain/user-service";
import { MediaRepository } from "../../../domain/media-repository";
import { CalendarListComponent } from "../../calendar/calendar-list.component";
import { ICommonUtilInterface } from "../../../domain/common/common-util.interface";
import { ChannelRepository } from "../../../domain/channel-repository";
import { IBlockRepository } from "../../../domain/blocks/i-block.repository";
import { ShowRepository } from "../../../domain/show-repository";
import { EditBlockViewModel } from "../edit-block-header/edit-block.view-model";
import moment from "moment";
import { UI } from "../../../services/ui.service";
import { NgxSmartModalService } from "ngx-smart-modal";
import { Subscription } from "rxjs";

@Component({
  selector: "evrideo-blocks-calendar",
  templateUrl: "../../calendar/calendar.component.html",
  styleUrls: ["../../calendar/calendar.component.scss"],
})
export class BlocksCalendarComponent extends CalendarComponent {
  private _lastCurrentChannelId: number;
  private _blockUpdatedSubscription: Subscription;
  constructor(
    router: Router,
    route: ActivatedRoute,
    calendarService: CalendarService,
    changeDetectorRef: ChangeDetectorRef,
    calendarSearchService: CalendarSearchService,
    socket: Socket,
    userService: UserService,
    _mediaRepository: MediaRepository,
    calendarList: CalendarListComponent,
    _commonUtils: ICommonUtilInterface,
    _channelRepository: ChannelRepository,
    _blocksRepository: IBlockRepository,
    _showRepository: ShowRepository,
    _ui: UI,
    _ngxSmartModalService: NgxSmartModalService,
  ) {
    super(
      router,
      route,
      calendarService,
      changeDetectorRef,
      calendarSearchService,
      socket,
      userService,
      _mediaRepository,
      calendarList,
      _commonUtils,
    );
    this.showCalendarHeader = false;
    this.showCurrentTimeIndicator = false;
    route.params.subscribe(async (params: any) => {
      console.log("BlocksCalendarComponent-> params->getByDates ", params);
      const blockId = parseInt(params.id);
      /*this.overrideCurrentChannel = await _channelRepository.getChannelById(1000000845);
      userService.setCurrentChannel(this.overrideCurrentChannel);*/
      const allBlocks = await _blocksRepository.get();
      const lastChannelId = (await userService.getCurrentChannel()).id;
      console.log(
        "BlocksCalendarComponent-> lastChannelId->getByDates ",
        lastChannelId,
      );
      this.overrideViewOption("list");

      this.calendarListStyle = { "margin-top": "0" };
      if (allBlocks.map((b) => b.id).includes(lastChannelId) === false) {
        console.log(
          "BlocksCalendarComponent-> setting _lastCurrentChannelId->getByDates ",
          lastChannelId,
        );
        this._lastCurrentChannelId = lastChannelId;
      }

      const currentBlock = allBlocks.find((b) => b.id === blockId);

      if (this.editBlockVM) {
        this.editBlockVM.onDestroy();
        if (this._blockUpdatedSubscription) {
          this._blockUpdatedSubscription.unsubscribe();
        }
      }
      this.editBlockVM = new EditBlockViewModel(
        currentBlock,
        _blocksRepository,
        _showRepository,
        calendarService,
        router,
        _ui,
        _ngxSmartModalService,
        changeDetectorRef,
        this.calendarListComponent,
      );
      this._blockUpdatedSubscription = this.editBlockVM.blockUpdated.subscribe(
        this.updateCalendarHeaderStyle.bind(this),
      );
      this.currentTime = moment().startOf("day");
      userService.currentChannelId = blockId;
      console.log("BlocksCalendarComponent-> blockId->getByDates ", blockId);
      this.updateCalendarHeaderStyle();
      //await calendarService.updateShows();

      await this.editBlockVM.onInit();
      //_showRepository.onShowsChange.next();
    });
  }

  updateCalendarHeaderStyle() {
    this.headerStyle = {
      "background-color": `${this.editBlockVM.isBlockStack ? "#00CA69" : "#CF5C81"}`,
    };
  }

  ngOnDestroy() {
    console.log("BlocksCalendarComponent-> ngOnDestroy->getByDates ");
    this.calendarService.clearCache(true);
    this.userService.currentChannelId = this._lastCurrentChannelId;

    this.editBlockVM.onDestroy();
    if (this._blockUpdatedSubscription) {
      this._blockUpdatedSubscription.unsubscribe();
    }

    super.ngOnDestroy();
  }
}
